// @flow
/* eslint-disable react/no-did-mount-set-state */
import React, { Component } from 'react';
import styled from 'react-emotion';
import consts, { colors, configStructure } from '../assets/scripts/constants';
import { getTax } from '../services/api.service';
import PaymentOptions from './PaymentOptions';

/**
 * Styles
 */

const Wrapper = styled('div')`
  display: flex;
  width: 100%;
  padding: ${2 * consts.cell}em 0 0;
  margin-left: auto;
  box-sizing: content-box;

  @media (min-width: 860px) {
    width: ${21 * consts.cell}em;
    padding: ${2 * consts.cell}em 0 ${consts.cellEm} ${consts.cellEm};
  }

  @media (min-width: 940px) {
    width: ${25 * consts.cell}em;
  }
`;

const Container = styled('div')`
  display: block;
  width: 100%;
  margin-left: auto;
  box-sizing: border-box;
  text-align: center;

  @media (min-width: 860px) {
    padding-right: ${2 * consts.cell}em;
    text-align: right;
  }

  > div {
    @media (min-width: 640px) {
      margin-left: ${consts.cellEm};
    }
  }
`;

const Price = styled('span')`
  display: inline-block;
  vertical-align: top;
  transform: translateY(-15%);
  text-align: right;

  > span:first-of-type {
    font-size: 5.4em;
    font-weight: 600;
  }

  > span:last-of-type {
    font-size: 2em;
    color: ${colors.grayDark};
    margin-left: 0.5em;
  }
`;

/**
 * Component: ConfiguratorPrice
 *
 * Shows all configuration selections.
 */
class ConfiguratorPrice extends Component<
  {
    configData: { [string]: Object },
    configOptions: { [string]: Object },
  },
  { tax: number }
> {
  state = { tax: 0 };

  componentDidMount() {
    // const cachedTax = localStorage.getItem('tax');
    // if (cachedTax) {
    //   this.setState({ tax: JSON.parse(cachedTax) });
    // } else {
    this.setTax();
    // }
  }

  async setTax() {
    let tax = 0;
    try {
      tax = await getTax();
    } catch (e) {
      console.error(e);
    }
    if (tax) {
      localStorage.setItem('tax', JSON.stringify(tax));
      this.setState({ tax });
    }
  }

  render() {
    const { tax } = this.state;
    const { configOptions } = this.props;
    let { configData } = this.props;
    const doors =
      configData.pa_yksittainen_pariovi &&
      configData.pa_yksittainen_pariovi.label === 'pariovi'
        ? 2
        : 1;
    let quantity = configData.quantity && +configData.quantity.value;
    quantity = Number.isFinite(quantity) ? quantity : 1;
    configData = { ...configData, quantity: { value: quantity } };

    let totalPrice = 0;

    // Reduce total price from config data, structure and options.
    if (Object.keys(configOptions).length) {
      totalPrice = configStructure.reduce((calcPrice, { slug, preselect }) => {
        let price = 0;
        if (configData[slug]) {
          ({ price } = configData[slug]);
        } else if (configOptions[slug] && configOptions[slug].terms) {
          configOptions[slug].terms.some(term => {
            if (term.slug === preselect) {
              ({ price } = term);
              return true;
            }
            return false;
          });
        }
        price = Number.isFinite(price) ? price : 0;
        return calcPrice + price;
      }, 0);
    }

    totalPrice = totalPrice * doors * quantity * (1 + tax / 100);

    return (
      <Wrapper>
        <Container>
          <Price>
            <span>{`${totalPrice.toFixed(2)}\u00A0€`}</span>
            <br />
            <span>{tax ? `Sisältää ${tax}%` : 'Ei sisällä'} alv</span>
          </Price>
          <PaymentOptions />
        </Container>
      </Wrapper>
    );
  }
}

export default ConfiguratorPrice;



// WEBPACK FOOTER //
// ./src/components/ConfiguratorPrice.js